'use client';

import { useParams } from 'next/navigation';

export const MatchesTopContainer = ({ children }: { children: React.ReactNode }) => {
	const params = useParams();

	return (
		<>
			{!params.matchId ? children : null}       
		</>
	);
};